import { render } from "./CenterLayout.vue?vue&type=template&id=454a954a&scoped=true"
import script from "./CenterLayout.vue?vue&type=script&lang=js"
export * from "./CenterLayout.vue?vue&type=script&lang=js"

import "./CenterLayout.vue?vue&type=style&index=0&id=454a954a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454a954a"]])

export default __exports__